import React, { useEffect, useState, useRef } from "react";
import logo from "../resources/images/logo.png";
import ConnectingButtons from "./ConnectingButtons";
import { connect } from "react-redux";
import { setIsRoomHost } from "../store/actions";
import { useHistory } from "react-router-dom";
import AuthModal from "./AuthModal/AuthModal";

import "./IntroductionPage.css";

const IntroductionPage = ({ setIsRoomHostAction, user }) => {
  const history = useHistory();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [photoURL, setPhotoURL] = useState(null);
  const imgRef = useRef(null);

  useEffect(() => {
    if (user?.photoURL) {
      // Use the photoURL directly without cache-busting to avoid rate limiting
      // Google profile images are already cached by the browser
      setPhotoURL(user.photoURL);
    } else {
      setPhotoURL(null);
    }
  }, [user?.photoURL]);

  const handleImageError = (e) => {
    // If image fails to load, try once more without cache-busting
    if (!imageError) {
      setImageError(true);
      if (imgRef.current) {
        imgRef.current.src = user.photoURL;
      }
    }
  };

  useEffect(() => {
    // localStorage.removeItem("roomId");
    // setIsRoomHostAction(true);
    // history.push("/join-room?host=true");
  }, []);

  const handleLoginClick = () => {
    setIsAuthModalOpen(true);
  };

  const handleCloseAuthModal = () => {
    setIsAuthModalOpen(false);
  };

  return (
    <div className="introduction_page_container">
      <div className="introduction_page_panel">
        <img src={logo} className="introduction_page_image" alt="GooN Logo"></img>
        <h1 className="introduction_page_title">Welcome to GooN</h1>
        <p className="introduction_page_subtitle">Secure video meetings for everyone</p>

        {/* Login/Profile Button */}
        <div className="auth_button_container">
          {user ? (
            <button
              className="user_profile_button"
              onClick={() => setIsAuthModalOpen(true)}
            >
              {photoURL ? (
                <img
                  ref={imgRef}
                  src={photoURL}
                  alt="Profile"
                  className="user_profile_avatar"
                  onError={handleImageError}
                />
              ) : (
                <div className="user_profile_avatar_placeholder">
                  {user.displayName ? user.displayName.charAt(0).toUpperCase() : "U"}
                </div>
              )}
              <span className="user_profile_name">{user.displayName || "Account"}</span>
            </button>
          ) : (
            <button
              className="login_button"
              onClick={handleLoginClick}
            >
              Sign In
            </button>
          )}
        </div>

        <ConnectingButtons
          setIsRoomHostAction={setIsRoomHostAction}
          onLoginClick={handleLoginClick}
        />

        <div className="introduction_features">
          <div className="feature_item">
            <span className="feature_icon">🔒</span>
            <span className="feature_text">Secure</span>
          </div>
          <div className="feature_item">
            <span className="feature_icon">⚡</span>
            <span className="feature_text">Fast</span>
          </div>
          <div className="feature_item">
            <span className="feature_icon">🎥</span>
            <span className="feature_text">HD Video</span>
          </div>
        </div>
      </div>

      {/* Auth Modal */}
      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={handleCloseAuthModal}
      />
    </div>
  );
};

const mapActionsToProps = (dispatch) => {
  return {
    setIsRoomHostAction: (isRoomHost) => dispatch(setIsRoomHost(isRoomHost)),
  };
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps, mapActionsToProps)(IntroductionPage);
